/* =====================================================================
   KICKFIT — OFERTA 3+1
   La fiecare 3 perechi de șosete eligibile cumpărate → 1 pereche cadou
   (Classic Lila), personalizată la fel ca perechile tale.
   (3 → 1 cadou, 6 → 2 cadouri, 9 → 3 cadouri etc.)

   - numără DOAR perechile eligibile (produse cu tag 'sosete'), nu valoarea
   - adaugă cadoul doar când pragul e atins; îl scoate automat sub prag
   - numărul de cadouri = perechi eligibile ÷ 3 (rotunjit în jos), ținut la zi automat
   - randează upsell-ul în: bara de sus, pagina de produs, colecție, coș
   - se actualizează la orice add/change/update pe coș, la revenirea
     în pagină (back/forward) și la revenirea în tab
   ===================================================================== */
(function () {
  'use strict';

  var DEBUG = /[?&]kf31debug=1/.test(window.location.search);
  var diag = { config: 'lipsă', errors: [] };

  function report(msg) {
    diag.errors.push(msg);
    if (window.console) console.error('[Kickfit 3+1] ' + msg);
    showDebug();
  }

  function showDebug() {
    if (!DEBUG || !document.body) return;
    var box = document.getElementById('kf31-debug');
    if (!box) {
      box = document.createElement('pre');
      box.id = 'kf31-debug';
      box.style.cssText = 'position:fixed;left:12px;bottom:12px;z-index:99999;max-width:92vw;max-height:60vh;overflow:auto;' +
        'background:#111;color:#39FF6A;border:1px solid #B026FF;border-radius:10px;padding:12px 14px;font:12px/1.5 monospace;white-space:pre-wrap;';
      document.body.appendChild(box);
    }
    box.textContent = JSON.stringify(diag, null, 2);
  }

  window.addEventListener('error', function (e) {
    if (e && e.filename && e.filename.indexOf('kickfit-promo-3plus1') > -1) report('Eroare JS: ' + e.message + ' (linia ' + e.lineno + ')');
  });

  var CFG = null;
  var cfgEl = document.getElementById('kf31-config');
  if (cfgEl) {
    try { CFG = JSON.parse(cfgEl.textContent); diag.config = 'ok'; }
    catch (err) { report('Configurarea (snippets/kf-promo-config.liquid) nu este JSON valid: ' + err.message); }
  } else if (window.KF_PROMO) {
    CFG = window.KF_PROMO; diag.config = 'ok (KF_PROMO)';
  } else {
    report('Lipsește configurarea. Verifică dacă theme.liquid conține {% render \'kf-promo-config\' %}.');
  }
  if (!CFG || !window.fetch) { showDebug(); return; }
  if (window.console) console.info('[Kickfit 3+1] activ');

  var T = CFG.threshold || 3;
  var ROOT = (CFG.root || '/').replace(/\/?$/, '/');
  var IS_CART = CFG.template === 'cart';
  var PERS_KEYS = ['Text', 'Numar', 'Steag'];
  // Perechea cadou e salvată ca detalii ale comenzii (atribute de coș) — NU ca produs → nu ajunge pe factură.
  var ATTR = { gift: 'Pereche cadou 3+1', qty: 'Cadou - Cantitate', Text: 'Cadou - Text', Numar: 'Cadou - Număr', Steag: 'Cadou - Steag' };

  var eligibleIds = {};
  (CFG.eligibleProductIds || []).forEach(function (id) { eligibleIds[String(id)] = true; });

  var giftVariants = CFG.giftVariants || [];
  var giftById = {};
  giftVariants.forEach(function (v) { giftById[String(v.id)] = v; });
  var giftProductIds = {};
  (CFG.giftProductIds || (CFG.giftProductId ? [CFG.giftProductId] : [])).forEach(function (id) { giftProductIds[String(id)] = true; });

  if (!giftVariants.length && window.console) {
    console.warn('[Kickfit 3+1] Nu există produse cadou. Adaugă tag-ul „kf-gift” pe produsele cadou (vezi snippets/kf-promo-config.liquid).');
  }

  var state = {
    cart: CFG.cart || null,
    busy: false,
    error: '',
    selectedPersKey: null,
    lastCount: null
  };

  /* ---------------- utilitare ---------------- */

  var nativeFetch = window.fetch.bind(window);

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    return new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      .format((Number(cents) || 0) / 100) + ' lei';
  }

  function pairs(n) { return n === 1 ? '1 pereche' : n + ' perechi'; }
  function giftsFor(n) { return Math.floor((Number(n) || 0) / T); }
  function giftsWord(g) { return g === 1 ? 'perechea cadou' : g + ' perechi cadou'; }
  function nextGiftHint(n) {
    var r = n % T;
    return (n >= T && r > 0) ? 'Mai adaugă încă ' + pairs(T - r) + ' și primești încă 1 pereche cadou.' : '';
  }

  function api(path, body) {
    return nativeFetch(ROOT + path.replace(/^\//, ''), {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Coșul nu a putut fi actualizat.');
        return data;
      });
    });
  }

  function getCart() { return api('cart.js?kf=' + Date.now()); }

  // Operațiile pe coș rulează strict una după alta (fără race conditions).
  var queue = Promise.resolve();
  function enqueue(task) {
    var run = queue.then(task);
    queue = run.catch(function () {});
    return run;
  }

  /* ---------------- analiza coșului ---------------- */

  function props(item) { return item.properties || {}; }
  function isFee(item) { return props(item)._kfFee === 'true'; }
  function isGift(item) {
    return !!giftById[String(item.variant_id)] ||
      !!giftProductIds[String(item.product_id)] ||
      !!props(item)._kfGift;
  }
  function isEligible(item) {
    return !isGift(item) && !isFee(item) && !!eligibleIds[String(item.product_id)];
  }

  function persKeyOf(p) {
    p = p || {};
    var vals = PERS_KEYS.map(function (k) { return String(p[k] || '').trim(); });
    return vals.join('') ? vals.join('|') : '';
  }

  function persLabel(p) {
    var out = [];
    if (p.Text) out.push('Text: ' + p.Text);
    if (p.Numar) out.push('Număr: ' + p.Numar);
    if (p.Steag) out.push('Steag: ' + String(p.Steag).replace(/^[A-Z]{2}\s+/, ''));
    return out.join(', ');
  }

  function analyze(cart) {
    var a = { eligibleQty: 0, giftLines: [], persList: [], eligibleLines: [], gift: '', giftQty: 0, giftPers: {} };
    if (!cart || !cart.items) return a;
    var attrs = cart.attributes || {};
    a.gift = String(attrs[ATTR.gift] || '').trim();
    a.giftQty = parseInt(attrs[ATTR.qty], 10) || 0;
    PERS_KEYS.forEach(function (k) { var v = String(attrs[ATTR[k]] || '').trim(); if (v) a.giftPers[k] = v; });
    var persMap = {};
    cart.items.forEach(function (item) {
      if (isGift(item)) { a.giftLines.push(item); return; }
      if (!isEligible(item)) return;
      a.eligibleQty += item.quantity;
      a.eligibleLines.push(item);
      var key = persKeyOf(props(item));
      if (!key) return;
      if (!persMap[key]) {
        var pp = {};
        PERS_KEYS.forEach(function (k) { if (props(item)[k]) pp[k] = String(props(item)[k]).trim(); });
        persMap[key] = { key: key, props: pp, label: persLabel(pp), count: 0 };
        a.persList.push(persMap[key]);
      }
      persMap[key].count += item.quantity;
    });
    a.persList.sort(function (x, y) { return y.count - x.count; });
    return a;
  }

  // Personalizarea pe care o primește cadoul: cea aleasă / cea existentă / cea mai frecventă.
  function pickPers(a, preferredKey) {
    if (!a.persList.length) return null;
    var keys = [preferredKey, state.selectedPersKey];
    for (var i = 0; i < keys.length; i++) {
      for (var j = 0; j < a.persList.length; j++) {
        if (keys[i] && a.persList[j].key === keys[i]) return a.persList[j];
      }
    }
    return a.persList[0];
  }

  function giftProps(pers) {
    var p = { '_kfGift': '1', 'Ofertă': '3+1 — pereche cadou' };
    if (pers) {
      PERS_KEYS.forEach(function (k) { if (pers.props[k]) p[k] = pers.props[k]; });
    }
    return p;
  }

  /* ---------------- coș: stare nesalvată pe pagina /cart ---------------- */

  // Pe pagina de coș, cantitățile se schimbă întâi în input-uri (până la „Actualizează coșul”).
  // Upsell-ul reacționează imediat la aceste valori.
  function pendingEligibleQty() {
    var rows = document.querySelectorAll('.cart-line-item[data-kf-product-id]');
    if (!rows.length) return null;
    var total = 0;
    rows.forEach(function (row) {
      if (row.classList.contains('cart-line-fee') || row.classList.contains('cart-line-gift')) return;
      if (!eligibleIds[row.getAttribute('data-kf-product-id')]) return;
      var input = row.querySelector('.kf-main-qty-input');
      total += input ? Math.max(0, parseInt(input.value, 10) || 0) : 0;
    });
    return total;
  }

  // formularul principal al coșului (cel cu cantitățile) — nu formularele din caseta 3+1
  function mainCartForm() {
    var row = document.querySelector('.kf-main-qty-input, .kf-fee-qty-input');
    return row ? row.closest('form') : null;
  }

  // la „Actualizează coșul” / „Finalizează comanda”: sub 3 perechi, cadoul se șterge odată cu salvarea
  function syncGiftInputs() {
    var pending = pendingEligibleQty();
    var form = mainCartForm();
    if (pending === null || !form) return;
    form.querySelectorAll('.kf31-clear-attr').forEach(function (el) { el.remove(); });
    if (!analyze(state.cart).gift) return;
    if (pending < T) {
      [ATTR.gift, ATTR.qty, ATTR.Text, ATTR.Numar, ATTR.Steag].forEach(function (name) {
        var inp = document.createElement('input');
        inp.type = 'hidden'; inp.className = 'kf31-clear-attr';
        inp.name = 'attributes[' + name + ']'; inp.value = '';
        form.appendChild(inp);
      });
    } else {
      // numărul de cadouri urmează noile cantități (3 → 1, 6 → 2, ...)
      var q = document.createElement('input');
      q.type = 'hidden'; q.className = 'kf31-clear-attr';
      q.name = 'attributes[' + ATTR.qty + ']'; q.value = String(giftsFor(pending));
      form.appendChild(q);
    }
  }

  function commitPending() {
    if (!IS_CART) return Promise.resolve();
    var form = mainCartForm();
    if (!form) return Promise.resolve();
    if (typeof window.kickfitSyncPersonalizationFees === 'function') window.kickfitSyncPersonalizationFees(false);
    syncGiftInputs();
    var updates = {}, any = false;
    form.querySelectorAll('input[name^="updates["]').forEach(function (input) {
      var m = input.name.match(/^updates\[(.+)\]$/);
      if (!m) return;
      updates[m[1]] = Math.max(0, parseInt(input.value, 10) || 0);
      any = true;
    });
    return any ? api('cart/update.js', { updates: updates }) : Promise.resolve();
  }

  /* ---------------- reguli (enforcement) ---------------- */

  // 1) sub 3 perechi eligibile → cadoul se scoate
  // 2) peste 3 perechi → maxim 1 bucată cadou
  // 3) personalizarea cadoului rămâne sincronizată cu perechile din coș
  function giftAttrs(label, pers, qty) {
    var out = {};
    out[ATTR.gift] = label || '';
    out[ATTR.qty] = label ? String(qty || 1) : '';
    PERS_KEYS.forEach(function (k) { out[ATTR[k]] = (label && pers && pers[k]) ? pers[k] : ''; });
    return out;
  }

  // 1) sub 3 perechi eligibile → cadoul (atributul) se șterge
  // 2) produsele cadou vechi (linii în coș din versiunile anterioare) se scot
  // 3) numărul de cadouri = perechi eligibile ÷ 3 (rotunjit în jos) și se ține la zi automat
  // 4) o variantă cadou care nu mai e în ofertă (ex. Negru) se șterge, ca să fie aleasă Lila
  function enforce(cart) {
    var a = analyze(cart);
    var body = {}, need = false;
    if (a.giftLines.length) {
      body.updates = {};
      a.giftLines.forEach(function (l) { body.updates[l.key] = 0; });
      need = true;
    }
    var G = giftsFor(a.eligibleQty);
    if (a.gift) {
      var stillOffered = !giftVariants.length || giftVariants.some(function (v) { return v.title === a.gift; });
      if (G < 1 || !stillOffered) { body.attributes = giftAttrs('', null, 0); need = true; }
      else if (a.giftQty !== G) {
        body.attributes = body.attributes || {};
        body.attributes[ATTR.qty] = String(G);
        need = true;
      }
    }
    var step = need ? api('cart/update.js', body) : Promise.resolve(cart);
    return step.then(function (c) { return { cart: c, changed: need }; });
  }

  /* ---------------- acțiuni ---------------- */

  function addGift(variantId) {
    return getCart().then(function (cart) {
      var a = analyze(cart);
      if (a.eligibleQty < T) throw new Error('Oferta 3+1 se deblochează când ai minimum 3 perechi în coș.');
      var v = giftById[String(variantId)];
      if (!v) throw new Error('Varianta cadou nu este disponibilă.');
      if (!v.available) throw new Error('Varianta ' + v.title + ' nu mai este în stoc.');
      // personalizarea: cea aleasă explicit → cea deja salvată pe cadou → cea a perechilor din coș
      var pers;
      if (state.selectedPersKey) { var sp = pickPers(a, state.selectedPersKey); pers = sp ? sp.props : {}; }
      else if (a.gift && Object.keys(a.giftPers).length) pers = a.giftPers;
      else { var ip = pickPers(a, null); pers = ip ? ip.props : {}; }
      return api('cart/update.js', { attributes: giftAttrs(v.title, pers, giftsFor(a.eligibleQty)) });
    });
  }

  function removeGift() {
    return api('cart/update.js', { attributes: giftAttrs('', null, 0) });
  }

  // „Adaugă încă o pereche” din coș: +1 la cea mai recentă pereche (cu tot cu taxa de personalizare).
  function addOneMore() {
    return getCart().then(function (cart) {
      var a = analyze(cart);
      var line = a.eligibleLines[0];
      if (!line) { window.location.href = CFG.socksUrl; return cart; }
      var updates = {};
      updates[line.key] = line.quantity + 1;
      var group = props(line)._kfGroup;
      if (group) {
        cart.items.forEach(function (it) {
          if (isFee(it) && props(it)._kfGroup === group) updates[it.key] = line.quantity + 1;
        });
      }
      return api('cart/update.js', { updates: updates });
    });
  }

  function runAction(task, opts) {
    opts = opts || {};
    state.busy = true; state.error = ''; renderAll();
    return enqueue(function () {
      return commitPending()
        .then(task)
        .then(function (cart) { return cart && cart.items ? cart : getCart(); })
        .then(enforce)
        .then(function (res) {
          state.cart = res.cart;
          updateBadge(res.cart);
          if (IS_CART && opts.reloadOnCart !== false) { window.location.reload(); return; }
        });
    }).catch(function (err) {
      state.error = (err && err.message) || 'A apărut o eroare. Încearcă din nou.';
    }).then(function () {
      state.busy = false; renderAll();
    });
  }

  var refreshTimer = null;
  function scheduleRefresh(delay) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, delay == null ? 120 : delay);
  }

  function refresh() {
    return enqueue(function () {
      return getCart().then(enforce).then(function (res) {
        state.cart = res.cart;
        if (res.changed) {
          updateBadge(res.cart);
          if (IS_CART) { safeReload(); return; }
        }
        renderAll();
      });
    }).catch(function () { renderAll(); });
  }

  function safeReload() {
    try {
      var k = 'kf31-reload', now = Date.now(), last = Number(sessionStorage.getItem(k)) || 0;
      if (now - last < 2000) return renderAll();
      sessionStorage.setItem(k, String(now));
    } catch (e) {}
    window.location.reload();
  }

  function updateBadge(cart) {
    if (!cart) return;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('has-items', cart.item_count > 0);
    });
  }

  /* ---------------- randare ---------------- */

  function countFor(mode, a) {
    if (IS_CART && (mode === 'cart' || mode === 'summary')) {
      var p = pendingEligibleQty();
      if (p !== null) return p;
    }
    return a.eligibleQty;
  }

  function productMessage(n) {
    if (n <= 0) return 'Cumpără 3 perechi și primești 1 pereche cadou din partea noastră!';
    if (n === 1) return 'Mai adaugă încă 2 perechi și primești 1 pereche cadou din partea noastră!';
    if (n === 2) return 'Mai adaugă încă 1 pereche și primești 1 pereche cadou din partea noastră!';
    var g = giftsFor(n);
    return g === 1 ? 'Felicitări! Ai deblocat oferta 3+1. Alege perechea cadou.'
      : 'Felicitări! Ai deblocat ' + g + ' perechi cadou. Alege perechea cadou.';
  }

  function cartMessage(n) {
    if (n <= 0) return 'Cumpără 3 perechi și primești 1 pereche cadou din partea noastră!';
    if (n === 1) return 'Mai adaugă 2 perechi și primești 1 pereche cadou!';
    if (n === 2) return 'Mai ai nevoie de o singură pereche pentru a primi una cadou!';
    var g = giftsFor(n);
    return g === 1 ? 'Ai deblocat oferta 3+1!' : 'Ai deblocat oferta 3+1: ' + g + ' perechi cadou!';
  }

  function progressHtml(n, mount) {
    var c = (n > 0 && n % T === 0) ? T : n % T;
    var fill = c <= 0 ? 0 : c >= T ? 100 : ((c - 1) / T) * 100;
    var prev = mount.getAttribute('data-kf31-fill');
    var steps = '';
    for (var i = 1; i <= T; i++) {
      steps += '<li class="kf31-step' + (c >= i ? ' is-done' : '') + '">' +
        '<span class="kf31-dot">' + (c >= i ? '✓' : i) + '</span>' +
        '<span class="kf31-lbl">' + pairs(i) + '</span></li>';
    }
    steps += '<li class="kf31-step kf31-step-gift' + (c >= T ? ' is-done' : '') + '">' +
      '<span class="kf31-dot" aria-hidden="true">+1</span><span class="kf31-lbl">Cadou</span></li>';
    return '<div class="kf31-progress" role="progressbar" aria-label="Progres către oferta 3+1" ' +
      'aria-valuemin="0" aria-valuemax="' + T + '" aria-valuenow="' + c + '">' +
      '<div class="kf31-track"><span class="kf31-fill" data-to="' + fill + '" style="width:' +
      (prev == null ? fill : prev) + '%"></span></div><ol class="kf31-steps">' + steps + '</ol></div>';
  }

  function swatchFor(title) {
    var t = String(title).toLowerCase();
    if (t.indexOf('negru') > -1 || t.indexOf('negre') > -1) return '#000000';
    if (t.indexOf('lil') > -1) return '#A99BC2';
    if (t.indexOf('mov') > -1) return '#6A1BFF';
    if (t.indexOf('albastru') > -1) return '#1D4FE0';
    if (t.indexOf('gri') > -1) return '#8C8C8C';
    if (t.indexOf('alb') > -1) return '#FFFFFF';
    return '#9a9a9a';
  }

  // finalizare directă (cu codul de reducere salvat, dacă există)
  function checkoutHref() {
    var code = '';
    try { code = (localStorage.getItem('kickfit_discount_code') || '').trim().toUpperCase(); } catch (e) {}
    if (code === 'KICKFIT10' || code === 'KICKFIT5') return ROOT + 'discount/' + code + '?redirect=' + encodeURIComponent('/checkout');
    return ROOT + 'checkout';
  }

  function giftPickerHtml(mode, a, n) {
    var gift = a.gift;
    var G = giftsFor(n);
    var html = '<div class="kf31-gift">';
    if (mode === 'product') {
      html += '<h3 class="kf31-gift-title">Alege-ți perechea cadou</h3>' +
        '<p class="kf31-gift-sub">Ai deblocat oferta 3+1. Alege una dintre variantele de mai jos.</p>';
    } else {
      html += '<p class="kf31-gift-label">Alege perechea cadou:</p>';
    }

    if (!giftVariants.length) {
      return html + '<p class="kf31-pers">Variantele pentru perechea cadou vor fi disponibile în curând.</p></div>';
    }

    html += '<div class="kf31-opts" role="radiogroup" aria-label="Perechea cadou">';
    giftVariants.forEach(function (v) {
      var selected = !!gift && gift === v.title;
      var value = v.price > 0 ? v.price : v.compareAt;
      html += '<button type="button" role="radio" aria-checked="' + selected + '" class="kf31-opt' +
        (selected ? ' is-selected' : '') + '" data-kf31-gift="' + v.id + '"' +
        (state.busy || !v.available ? ' disabled' : '') + '>' +
        '<span class="kf31-radio" aria-hidden="true"></span>' +
        '<span class="kf31-opt-swatch" style="background-color:' + swatchFor(v.title) + '" aria-hidden="true"></span>' +
        (v.image ? '<img class="kf31-opt-img" src="' + esc(v.image) + '" alt="" loading="lazy" width="52" height="52">' : '') +
        '<span class="kf31-opt-body"><span class="kf31-opt-name">' + esc(v.title) + '</span>' +
        '<span class="kf31-opt-price">' + (value > 0 ? '<s>' + money(value) + '</s>' : '') +
        '<b>' + (v.available ? '0 lei' : 'Stoc epuizat') + '</b></span></span></button>';
    });
    html += '</div>';

    // personalizarea cadoului
    if (!a.persList.length) {
      html += '<p class="kf31-pers">Perechile din coș nu sunt personalizate, așa că ' + (G > 1 ? 'perechile cadou vor fi trimise fără personalizare.' : 'perechea cadou va fi trimisă fără personalizare.') + '</p>';
    } else if (a.persList.length === 1) {
      html += '<p class="kf31-pers">' + (G > 1 ? 'Perechile cadou vor fi brodate' : 'Perechea cadou va fi brodată') + ' la fel ca perechile tale: <strong>' +
        esc(a.persList[0].label) + '</strong></p>';
    } else {
      var current = pickPers(a, gift ? persKeyOf(a.giftPers) : null);
      html += '<label class="kf31-pers">' + (G > 1 ? 'Ce personalizare să aibă perechile cadou?' : 'Ce personalizare să aibă perechea cadou?') + '<select data-kf31-pers' +
        (state.busy ? ' disabled' : '') + '>';
      a.persList.forEach(function (p) {
        html += '<option value="' + esc(p.key) + '"' + (current && current.key === p.key ? ' selected' : '') + '>' +
          esc(p.label) + ' (' + pairs(p.count) + ')</option>';
      });
      html += '</select></label>';
    }

    if (state.busy) html += '<p class="kf31-status is-busy" role="status">Se actualizează coșul…</p>';
    else if (state.error) html += '<p class="kf31-status is-error" role="alert">' + esc(state.error) + '</p>';
    else if (gift) {
      html += '<p class="kf31-status" role="status">' + (G > 1 ? '✓ ' + G + ' perechi cadou au fost adăugate în coș.' : '✓ Perechea cadou a fost adăugată în coș.') + '</p>';
      if (mode === 'product') {
        html += '<div class="kf31-actions"><a class="btn kf31-btn" href="' + esc(checkoutHref()) + '">Finalizare comandă →</a>' +
          '<a class="kf31-link" href="' + esc(CFG.cartUrl) + '">Vizualizare coș</a></div>';
      }
    }

    return html + '</div>';
  }

  function renderModule(mount, mode, a) {
    var n = countFor(mode, a);
    var unlocked = n >= T;
    var serverGift = a.gift;
    var html = '<div class="kf31 kf31--' + mode + (unlocked ? ' is-unlocked' : '') + '">';

    html += '<div class="kf31-head"><span class="kf31-mark" aria-hidden="true">3+1</span><div>' +
      '<p class="kf31-msg" aria-live="polite">' + esc(mode === 'cart' ? cartMessage(n) : productMessage(n)) + '</p>';
    if (!unlocked) {
      html += '<p class="kf31-sub">Ofertă permanentă: la fiecare 3 perechi cumpărate primești încă 1 pereche cadou. Perechea cadou se brodează la fel ca perechile tale.</p>';
    } else if (nextGiftHint(n)) {
      html += '<p class="kf31-sub">' + nextGiftHint(n) + '</p>';
    }
    html += '</div></div>' + progressHtml(n, mount);

    // caseta „Cât plătești cu oferta 3+1” e calculată în Liquid din prețul real — o păstrăm
    if (mount.__kfValueHTML == null) {
      var v = mount.querySelector('.kf31-value');
      mount.__kfValueHTML = v ? v.outerHTML : '';
    }
    if (mount.__kfValueHTML && (mode === 'product' || !unlocked)) html += mount.__kfValueHTML;

    // pagina de produs: arată dacă cantitatea selectată deblochează oferta
    if (mode === 'product' && !unlocked) {
      var qtyInput = document.getElementById('qtyInput');
      var q = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      if (n + q >= T) {
        html += '<p class="kf31-hint">' + (q === 1 ? 'Cu perechea selectată acum' : 'Cu cele ' + q + ' perechi selectate acum') +
          ' deblochezi oferta 3+1.</p>';
      }
    }

    if (unlocked) {
      if (mode === 'strip') {
        html += '<div class="kf31-actions"><a class="btn kf31-btn" href="' + esc(CFG.cartUrl) + '">Alege perechea cadou în coș</a></div>';
      } else {
        html += giftPickerHtml(mode, a, n);
      }
    } else if (mode === 'cart') {
      html += '<div class="kf31-actions">';
      if (n === 2 && a.eligibleLines.length) {
        html += '<button type="button" class="btn kf31-btn" data-kf31-action="more"' + (state.busy ? ' disabled' : '') +
          '>Adaugă încă o pereche</button><a class="kf31-link" href="' + esc(CFG.socksUrl) + '">sau alege alt model</a>';
      } else {
        html += '<a class="btn kf31-btn" href="' + esc(CFG.socksUrl) + '">Vezi șosetele</a>';
      }
      html += '</div>';
      if (state.error) html += '<p class="kf31-status is-error" role="alert">' + esc(state.error) + '</p>';
    }

    if (mode === 'cart' && serverGift && !unlocked) {
      html += '<p class="kf31-note is-warn">Perechea cadou va fi eliminată la actualizarea coșului, pentru că oferta 3+1 necesită minimum 3 perechi.</p>';
    } else if (mode === 'cart' && n !== a.eligibleQty) {
      html += '<p class="kf31-note">Ai modificat cantitățile. Apasă „Actualizează coșul” pentru a le salva.</p>';
    }

    html += '</div>';

    var wasUnlocked = mount.getAttribute('data-kf31-unlocked') === '1';
    mount.innerHTML = html;
    mount.setAttribute('data-kf31-unlocked', unlocked ? '1' : '0');
    if (unlocked && !wasUnlocked && mount.hasAttribute('data-kf31-rendered')) {
      mount.firstChild.classList.add('kf31-pop');
    }
    mount.setAttribute('data-kf31-rendered', '1');

    var fillEl = mount.querySelector('.kf31-fill');
    if (fillEl) {
      var to = fillEl.getAttribute('data-to');
      var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
      raf(function () { raf(function () { fillEl.style.width = to + '%'; }); });
      mount.setAttribute('data-kf31-fill', to);
    }
  }

  function renderSummary(mount, a) {
    var n = countFor('summary', a);
    var gift = a.gift;
    var G = giftsFor(n);
    var left, right, cls = 'kf31-summary';
    if (n < T) {
      left = 'Oferta 3+1';
      right = 'încă ' + pairs(T - n) + ' până la cadou';
    } else if (gift) {
      cls += ' is-unlocked';
      left = (G > 1 ? G + ' perechi cadou 3+1' : 'Pereche cadou 3+1') + ' (' + esc(gift) + ')';
      right = '0,00 lei';
    } else {
      cls += ' is-unlocked';
      left = G > 1 ? 'Oferta 3+1 deblocată (' + G + ' perechi cadou)' : 'Oferta 3+1 deblocată';
      right = '<a href="#kf31-cart">Alege perechea cadou</a>';
    }
    mount.innerHTML = '<div class="' + cls + '"><span>' + left + '</span><span>' + right + '</span></div>';
  }

  function renderTicker(el, a) {
    var n = a.eligibleQty, gift = a.gift, text;
    var G = giftsFor(n);
    if (n <= 0) text = 'Oferta 3+1: la fiecare 3 perechi, a 4-a e cadou';
    else if (n < T) text = 'Încă ' + pairs(T - n) + ' până la perechea cadou';
    else if (gift) text = G === 1 ? 'Oferta 3+1 activă — cadoul e în coș' : 'Oferta 3+1 activă — ' + G + ' perechi cadou în coș';
    else text = 'Ai deblocat 3+1 — alege cadoul din coș';
    if (el.textContent !== text) el.textContent = text;
  }

  function renderAll() {
    var a = analyze(state.cart);
    document.querySelectorAll('[data-kf-promo]').forEach(function (mount) {
      var mode = mount.getAttribute('data-kf-promo');
      if (IS_CART && mode === 'cart') {
        if (mount.__kfServerHTML == null) mount.__kfServerHTML = mount.innerHTML;
        var pending = pendingEligibleQty();
        if (pending === null || pending === a.eligibleQty) {
          if (mount.innerHTML !== mount.__kfServerHTML) mount.innerHTML = mount.__kfServerHTML;
          return;
        }
      }
      if (mode === 'ticker') renderTicker(mount, a);
      else if (mode === 'summary') renderSummary(mount, a);
      else renderModule(mount, mode, a);
    });
  }

  /* ---------------- evenimente ---------------- */

  document.addEventListener('click', function (e) {
    var giftBtn = e.target.closest('[data-kf31-gift]');
    // formular Shopify nativ — doar în coș (pe pagina de produs butoanele stau în formularul produsului, dar se tratează prin JS)
    if (giftBtn && IS_CART && giftBtn.form) return;
    if (giftBtn) {
      e.preventDefault();
      if (giftBtn.disabled || state.busy) return;
      var id = giftBtn.getAttribute('data-kf31-gift');
      runAction(function () { return addGift(id); });
      return;
    }
    var more = e.target.closest('[data-kf31-action="more"]');
    if (more) {
      e.preventDefault();
      if (state.busy) return;
      runAction(addOneMore);
      return;
    }
    var rm = e.target.closest('.kf-gift-remove');
    if (rm) {
      e.preventDefault();
      if (state.busy) return;
      runAction(removeGift);
      return;
    }
    // butoanele +/− de pe pagina de produs (rulează după handler-ele existente)
    if (e.target.closest('#qtyMinus, #qtyPlus')) setTimeout(renderAll, 0);
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-kf31-pers]');
    if (!sel) return;
    state.selectedPersKey = sel.value;
    var a = analyze(state.cart);
    var cur = giftVariants.filter(function (v) { return v.title === a.gift; })[0];
    if (cur && a.eligibleQty >= T) {
      var giftVariant = cur.id;
      runAction(function () { return addGift(giftVariant); });
    } else {
      renderAll();
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches('#qtyInput, .kf-main-qty-input')) {
      if (IS_CART) syncGiftInputs();
      renderAll();
    }
  });

  // Pagina de coș: la „Actualizează coșul” / „Finalizează comanda” / ✕,
  // cadoul este scos automat dacă noile cantități coboară sub prag.
  document.addEventListener('submit', function (e) {
    if (IS_CART && e.target === mainCartForm()) syncGiftInputs();
  }, true);

  // Orice alt cod care modifică coșul (pagina de produs, șapcă, aplicații) → re-verificare.
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function () { scheduleRefresh(); }, function () {});
    }
    return p;
  };

  window.addEventListener('pageshow', function (e) { if (e.persisted) scheduleRefresh(0); });
  var lastVisible = 0;
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    if (Date.now() - lastVisible < 2000) return;
    lastVisible = Date.now();
    scheduleRefresh(0);
  });

  window.KFPromo31 = { refresh: refresh, analyze: function () { return analyze(state.cart); } };

  // prima randare din coșul livrat de Liquid, apoi verificare pe server
  diag.template = CFG.template;
  diag.produseEligibile = (CFG.eligibleProductIds || []).length;
  diag.variantaCadou = giftVariants.map(function (v) { return v.title + ' #' + v.id; });
  function updateDiag() {
    var a = analyze(state.cart);
    diag.perechiEligibileInCos = a.eligibleQty;
    diag.cadouInCos = a.gift || '(niciunul)';
    diag.liniiCos = ((state.cart && state.cart.items) || []).map(function (i) {
      return i.quantity + 'x ' + i.product_title + ' (product ' + i.product_id + (eligibleIds[String(i.product_id)] ? ', ELIGIBIL' : '') + ')';
    });
    showDebug();
  }
  var _renderAll = renderAll;
  renderAll = function () {
    try { _renderAll(); } catch (err) { report('Randare: ' + err.message); }
    if (DEBUG) updateDiag();
  };
  document.documentElement.setAttribute('data-kf31', 'on');
  renderAll();
  scheduleRefresh(0);
})();
